import React from "react";
import { RegistrationItem } from "../../../models/registrations/registrations";
import { FormatCurrencyValue } from "../../../utils/currency";
import GACurrencyInput, { GACurrencyInputOnChangeValues } from "../GACurrencyInput";
import { LineItem } from "../../LineItems/LineItem";
import { DonationConfiguration, LineItemTypes } from "../../LineItems/LineItemTypes/LineItemTypes";
import { chooseYourOwnPriceConfiguration, LineItemUnitPriceTypes } from "../../LineItems/UnitPriceTypes/LineItemUnitPriceTypes";

interface DonationItemPanelProps {
    registrationItem: RegistrationItem,
    currentTime: moment.Moment,
    adjustGrandTotal: (arg0: number) => void,
    donationMinimum: number,
    setDisplayError: (isError: boolean) => void,
    adjustCartItem: (id: number, cart: LineItem) => void,
    disableInputs: boolean
}


const DonationItemPanel = (props: DonationItemPanelProps) => {

    const [amountValid, setAmountValid] = React.useState<boolean>(false);
    const [amount, setAmount] = React.useState<FormatCurrencyValue>({float : 0});



    const currency = {
        name: 'USD',
        localization: Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }),
        formatting: {
            prefix: '$',
            suffix: '',
            decimalSeparator: '.',
            groupSeparator: ',',
            decimalLimit: 2
        }
    }



    React.useEffect(() => 
    {
        const cartItem: LineItem = 
        {
            itemFormat: LineItemTypes.Donation,
            itemConfiguration: 
            {
                dbId: props.registrationItem.id,
                componentName:'GADonationData',
                loggedInUserName: undefined
            } as DonationConfiguration,
            name: props.registrationItem.displayName,
            unitPriceFormat: LineItemUnitPriceTypes.ChooseYourOwn,
            displayOrd: props.registrationItem.displayOrd ?? 0,
            defaultPriceDisplay: amount.formatted,
            unitPriceConfiguration: 
            {
                    componentName: 'GADonationUnitPrice',
                    maxAmount: 9999.99,
                    minAmount: 2.50,
                    defaultPrice: {
                        currency: {
                            name: 'USD',
                            localization: Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: 'USD'
                            }),
                            formatting: {
                                prefix: '$',
                                suffix: '',
                                decimalSeparator: '.',
                                groupSeparator: ',',
                                decimalLimit: 2
                            }
                        },
                        value: amount
                    }
            } as chooseYourOwnPriceConfiguration
        };

        props.adjustCartItem(props.registrationItem.id, cartItem);
    }, [amount]);



    const adjustTotal = (prev: FormatCurrencyValue, next: FormatCurrencyValue) =>
    {
        if (prev?.float != null && next?.float != null)
        {
            props.adjustGrandTotal(next?.float - prev?.float);
        }
    }



    const validateAmount = (values?: GACurrencyInputOnChangeValues) => 
    {
        const prevAmount = amount;
        if(values?.float != null)
        {
            setAmount(values);
            adjustTotal(prevAmount, values);

            if (values?.float && values.float >= props.donationMinimum)
            {
                setAmountValid(true);
            }
            else
            {
                setAmountValid(false);
            }
        }
        else
        {
            setAmount({});
            adjustTotal(prevAmount, {float : 0});
            setAmountValid(false);
        }
    }



    const checkErrorDisplay = (values: GACurrencyInputOnChangeValues) =>  
    {
        setAmount(values);
        props.setDisplayError((values?.float == null || values?.float == 0) ? false : !amountValid);
    }



    return(
        <div className='colPanel-lineItem'>
            <div className='leftAlign'>
                <b>{props.registrationItem.displayName}</b>
            </div>
            <div className='colPanel-buttonGroup'>
                <GACurrencyInput
                    className='donationLineItemInput'
                    name='Donation Input'
                    currency={currency}
                    min={0}
                    max={9999.99}
                    defaultValue={0}
                    onValueChange={validateAmount}
                    onInputBlur={checkErrorDisplay}
                    disabled={props.disableInputs}
                />

            </div>
        </div>
    )
}

export default DonationItemPanel;